import React, { useEffect, useState } from 'react'
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/SelectItem/selectItem.scss';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import { Box, Checkbox, Chip, FormControl, InputAdornment, Modal, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import requestEmptyIcon from '../../../../../../asset/svg/requestEmptyIcon.svg';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { HIDE_MODAL_SELECT_ITEM, IS_CHECKED, SELECTED_DATA_DECREMENT, SELECTED_DATA_INCREMENT, SET_PURCHASED_DATA, SET_SELECT_PURCHASED_DATA, SHOW_MODAL_ASSETGROUP } from '../../../../../../sagas/type';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const getItemsType = (items, key = "type") => {
    const types = []
    if (items && items.length) {
        for (const item of items) {
            const value = item[key]
            if (!types.includes(value)) {
                types.push(value)
            }
        }
    }
    return types

}
const initialOpt = {
    type: [],
    name: ""
}
function SelectItem(props) {
    const dispatch = useDispatch();
    const { RegisterAssetDataPurchase } = useSelector(mapStateToProps);
    const [filterOpen, setFilterOPen] = useState(false)
    const { onDone } = props;
    const [filterOption, setFilterOption] = useState(initialOpt)
    const [items, setItems] = useState([])
    const [checkedObject, setCheckedObject] = useState()

    const handleBack = () => {
        dispatch({ type: HIDE_MODAL_SELECT_ITEM })
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
    }

    const handleCheckBoxChange = (selectData) => {
        dispatch({
            type: IS_CHECKED,
            payload: selectData,
        })
    };

    const handleDone = () => {
        onDone()
    }

    const handleCountChange = (selectedData, type) => {
        setCheckedObject(selectedData)
        if (type) {
            dispatch({
                type: SELECTED_DATA_INCREMENT,
                payload: selectedData,
            })
        } else {
            dispatch({
                type: SELECTED_DATA_DECREMENT,
                payload: selectedData,
            })
        }
        handleIncreaseCount(selectedData)

    }

    useEffect(() => {
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase?.length) {
            const filterData = RegisterAssetDataPurchase?.filter((item) => item?.purchaseId == checkedObject?.purchaseId)
            handleIncreaseCount(filterData)
        }
    }, [RegisterAssetDataPurchase])

    const updateFilteredData = () => {
        const filteredData = RegisterAssetDataPurchase.filter(doc => {
            let flag = true;
            const { name, type } = filterOption

            if (name || type.length) {
                const nameCondition = doc.name.toLowerCase().includes(name.toLowerCase());
                const typesCondition = doc.type.toLowerCase().includes(name.toLowerCase());
                const typeCondition = type.includes(doc.type)
                if (name && type.length) {
                    if (!((nameCondition || typesCondition) && typeCondition)) flag = false
                } else {
                    if (!(!type.length && (nameCondition || typesCondition) || !name && typeCondition)) flag = false
                }
            }
            return flag
        })
        setItems(filteredData)
    }

    const handleTypeChange = (event) => {
        const { value } = event.target;
        const filterType = [...filterOption.type];
        const index = filterType.indexOf(value)
        if (index !== -1) {
            filterType.splice(index, 1)
        } else {
            filterType.push(value)
        }
        setFilterOption(prev => ({ ...prev, type: filterType }))
    }

    const handleSearch = (event) => {
        const { value } = event.target;
        setFilterOption(prev => ({ ...prev, name: value }))
    }

    useEffect(() => {
        if (RegisterAssetDataPurchase && RegisterAssetDataPurchase.length) {
            updateFilteredData()
        }
    }, [filterOption, RegisterAssetDataPurchase])

    const handleIncreaseCount = (selectedData) => {
        const result = items?.reduce((result, current) => {
            const existingObject = result.find(item => item.name === current.name);
            if (existingObject) {
                existingObject.totalUnits += current.totalUnits;
                existingObject.issuedCount += current.issuedCount;
                existingObject.nonIssuedCount += current.nonIssuedCount;
                existingObject.combineObject = true
            } else {
                result.push({ ...current });
            }

            return result;
        }, []);
        const duplicateNames = items?.reduce((result, currentPurchase, index, array) => {
            const isDuplicate = array.findIndex(p => p.name === currentPurchase.name) !== index;

            if (isDuplicate && !result.includes(currentPurchase.name)) {
                result.push(currentPurchase.name);
            }
            return result;
        }, []);
        const filterData = items?.filter((item) => item?.name == selectedData[0]?.name)
        const duplicate = filterData?.filter(purchase => duplicateNames?.includes(purchase.name))?.sort((a, b) => a?.nonIssuedCount - b?.nonIssuedCount);
        const duplicateObjects = generatePayload(duplicate, selectedData[0]?.count);
        if (duplicateObjects?.length > 0) {
            dispatch({
                type: SET_PURCHASED_DATA,
                payload: duplicateObjects,
            })
        }
        for (const obj of duplicateObjects) {
            if (selectedData[0]?.count <= obj?.nonIssuedCount) {
                const filterObj = result?.map((item) => {
                    if (item?.name === selectedData[0]?.name) {
                        return { ...item, purchaseId: obj?.purchaseId, nonIssuedCount: obj?.nonIssuedCount };
                    }
                    return item;
                }).filter(Boolean);
                setItems(filterObj)
                break;
            }
        }
    };

    const generatePayload = (duplicate, quantity) => {
        const payloadData = [];

        for (let i = 0; i < duplicate.length; i++) {
            const { purchaseId, nonIssuedCount, checked } = duplicate[i];

            if (quantity <= nonIssuedCount) {
                payloadData.push({ purchaseId, quantity });
                break;
            } else if (quantity > 0) {
                payloadData.push({ purchaseId, quantity: nonIssuedCount });
                quantity -= nonIssuedCount;
            }
        }
        return payloadData;
    };


    return (
        <div className='SelectItem-Container'>
            <div className='SelectItem-Container_header'>
                <div className='SelectItem-Container_head-height'>
                    <img className='SelectItem-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='SelectItem-Container_header_content'>Select Items</span>
                </div>

                <div className='SelectItem-Container_registerData_buttonContainer'>
                    <button type='submit' disabled={''} className='SelectItem-Container_registerData_buttonContainer_active-button' onClick={handleDone}>Done</button>
                </div>

            </div>
            <div className='SelectItem-Container_searchcontainer'>
                <FormControl sx={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField autoComplete="off" size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={filterOption.name}
                        InputProps={{ startAdornment: (<InputAdornment position='start'>{filterOption.name.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                </FormControl>
            </div>
            <div className='SelectItem-Container_filterByCategory-header'>
                <div className='SelectItem-Container_filterByCategory' onClick={() => setFilterOPen(true)}>
                    <LanguageIcon sx={{ color: "rgba(255, 255, 255, 0.50)", width: "15px", height: "15px", border: "5px" }} />
                    <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 700, fontSize: '10px', lineHeight: '16px' }}>Filter by Category </Typography>
                    <KeyboardArrowDownIcon sx={{ color: "rgba(255, 255, 255, 0.50)", width: "24px", height: "24px", border: "5px" }} />
                </div>
            </div>
            <Modal
                open={filterOpen}
                onClose={() => setFilterOPen(false)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <div className='SelectItem-Container_filter-modal'>
                    <Box sx={{ backgroundColor: '#0B245F', borderRadius: '1rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', }}>
                        <HorizontalRuleIcon onClick={() => setFilterOPen(false)} sx={{ top: 10, left: "50%", position: "absolute", width: "30px", height: "3px", opacity: 0.4, background: "#FFF" }} />
                        <div style={{ padding: "1rem", marginTop: "1rem" }}>
                            <div>
                                <Typography sx={{ color: "#FFF", fontSize: "16px", fontWeight: 700, paddingLeft: "0.7rem" }}>Filter By Category</Typography>
                            </div>
                            <div>
                                {getItemsType(RegisterAssetDataPurchase)?.map((category, index) => {
                                    return (
                                        <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                                            <Checkbox onChange={handleTypeChange} checked={filterOption?.type.includes(category)}  {...label} value={category} color="primary" sx={{
                                                color: "#fff",
                                                '&.Mui-checked': {
                                                    color: "#8074FF",
                                                    opacity: "1"
                                                },
                                                opacity: "0.3"
                                            }} />
                                            <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 600 }}>{category}</Typography>
                                        </div>
                                    )
                                })
                                }

                            </div>
                            <div className='SelectItem-Container_filter-Download-button'>
                                <button type='submit' disabled={''} className='SelectItem-Container_filter-Download-button_active-button' onClick={() => setFilterOPen(false)}>Done</button>
                            </div>
                        </div>
                    </Box>
                </div>
            </Modal>
            {RegisterAssetDataPurchase?.length > 0 ? items?.reduce((result, current) => {
                const existingObject = result.find(item => item.name === current.name);
                if (existingObject) {
                    existingObject.totalUnits += current.totalUnits;
                    existingObject.issuedCount += current.issuedCount;
                    existingObject.nonIssuedCount += current.nonIssuedCount;
                    existingObject.combineObject = true
                } else {
                    result.push({ ...current });
                }

                return result;
            }, [])?.map((selectData) => {
                return (
                    <Box key={selectData?.purchaseId} sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '0.5rem', marginBottom: '10px' }}
                    // onClick={() => handleSelectItem(selectData)}
                    >
                        <div style={{ display: "flex", flexDirection: "row", alignContent: "flex-start" }}>
                            <div>
                                <Checkbox onChange={() => handleCheckBoxChange(selectData)} checked={selectData?.checked} {...label} color="primary" sx={{
                                    color: "#fff",
                                    '&.Mui-checked': {
                                        color: "#8074FF",
                                        opacity: "1"
                                    },
                                    opacity: "0.3"
                                }} />
                            </div>
                            <div style={{ width: "100%", padding: "0.6rem" }}>
                                <div className='SelectItem-Container_card-Parent-Container'>
                                    <div className="SelectItem-Container_card-Heading">
                                        {/* <Typography sx={{ color: "rgba(255, 255, 255, 0.40)", fontWeight: 400, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }} value="name">{selectData?.purchaseId}</Typography> */}
                                        <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px', lineHeight: '17px', padding: '0px' }}>{selectData?.type} - {selectData?.name}</Typography>
                                    </div>
                                    <div className="SelectItem-Container_card-Count">
                                        <Stack direction="row" spacing={1} className='SelectItem-Container_Stock-chip' sx={{ border: "1px solid #12B9DD" }}>
                                            <Chip label={`${selectData?.nonIssuedCount}` + " " + "Left"} className='SelectItem-Container_Store-chip' sx={{ color: "#12B9DD", border: "none" }} variant="outlined" />
                                        </Stack>
                                    </div>
                                </div>
                                <div>
                                    <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px', lineHeight: '16px', textTransform: 'capitalize' }}>{selectData?.description}</Typography>
                                </div>
                                {selectData?.checked && (<div style={{ display: "flex", flexDirection: "row", padding: "4px 2px 2px 2px" }}>
                                    <button disabled={selectData?.count <= 1} className="SelectItem-Container_btn-disable-count" onClick={() => handleCountChange(selectData)}><RemoveCircleOutlineIcon sx={{ color: selectData?.count <= 1 ? 'rgba(255, 255, 255, 0.30)' : '#8074FF', width: "24px", height: "24px", border: "5px" }} /></button>
                                    <Typography sx={{ padding: "1px 4px", color: "#FFF", fontSize: "15px" }}>{selectData?.count}</Typography>
                                    <button disabled={selectData?.count == selectData?.nonIssuedCount} className="SelectItem-Container_btn-disable-count" onClick={() => handleCountChange(selectData, 'Increment')}><AddCircleOutlineRoundedIcon sx={{ color: selectData?.count == selectData?.nonIssuedCount ? 'rgba(255, 255, 255, 0.30)' : '#8074FF', width: "24px", height: "24px" }} /></button>
                                </div>)}
                            </div>
                        </div>
                    </Box>
                )
            }) :
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                        <img style={{ heigth: '54px', width: '68px' }} src={requestEmptyIcon} alt="" />
                    </div>
                    <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Items Yet</Typography>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        RegisterAssetDataPurchase: state?.attendanceConfig?.RegisterAssetDataPurchase,
    }
}

export default SelectItem